import { DatePicker } from '@atlaskit/datetime-picker';
import Select from '@atlaskit/select';
import Textfield from '@atlaskit/textfield';
import { DateUtils } from '@atlassian/mpac-utils';
import { DateRange, Reports, SalesBy } from "./filtersOptions";
const dateRangeFilter = {
  label: 'Date range',
  data: DateRange,
  queryParam: 'period',
  component: Select
};
const allFilters = {
  sales: [dateRangeFilter, {
    label: 'Sales by',
    data: SalesBy,
    queryParam: 'metric',
    component: Select
  }, {
    label: 'Search by app name',
    queryParam: 'appName',
    component: Textfield,
    width: '300px'
  }],
  evaluations: [dateRangeFilter],
  feedback: [dateRangeFilter],
  conversions: [dateRangeFilter],
  renewals: [dateRangeFilter],
  churn: [dateRangeFilter],
  transactions: [dateRangeFilter],
  licenses: [dateRangeFilter],
  'feedback-details': [dateRangeFilter]
};

const getReportsNameFilter = value => ({
  label: 'Reports',
  data: Reports,
  appendUrl: true,
  component: Select,
  value: Reports.find(report => report.value === value)
});

const disableFutureDate = date => DateUtils.isFutureDate(new Date("".concat(date, ", 0:0:0")));

const getCustomDateFilter = () => [{
  label: 'Start date',
  queryParam: 'startDate',
  component: DatePicker,
  attributes: {
    disabledDateFilter: disableFutureDate
  }
}, {
  label: 'End date',
  queryParam: 'endDate',
  component: DatePicker,
  attributes: {
    disabledDateFilter: disableFutureDate
  }
}]; // This function includes (Start & End) Date filter when user select custom date


const includeCustomDateFilters = filters => {
  const dateRangeIndex = filters.findIndex(filter => filter.queryParam === 'period');
  return [...filters.slice(0, dateRangeIndex + 1), ...getCustomDateFilter(), ...filters.slice(dateRangeIndex + 1)];
}; // Main function which will return all Filters for a given Report


export const getFilters = (reportName, queryParams) => {
  let filters = [getReportsNameFilter(reportName), ...(allFilters[reportName] || [])];

  if (queryParams.period === 'custom') {
    filters = includeCustomDateFilters(filters);
  }

  return filters;
};